import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useRetrieveZonesIndicators } from "@planzone/view-models";

import { Props } from "./types";
import { Loader } from "./loader";
import { Zone } from "./zone";
import { Placeholder } from "./placeholder";
import styles from "./styles.scss";
import { InfiniteScroll, Flag } from "@common/infiniteScroll";

function ZonesList(props: Props) {
  const filter = {
    projects: [],
    projectStatuses: [],
    projectsTags: [],
  };
  const {
    zones,
    index,
    canRetrieveNextZonesIndicators,
    isRequestPending,
    retrieveZonesIndicators,
  } = useRetrieveZonesIndicators(filter, "ascendingName", 10);

  return (
    <>
      <InfiniteScroll>
        {() => (
          <>
            <ul
              className={classNames(styles.zonesList, {
                [styles.closed]: !props.isSideBarOpen,
              })}
            >
              {[...zones].map((zone) => (
                <li
                  key={zone.uuid}
                  className={styles.item}
                  onClick={() => {
                    props.setIsSubMenuShown(false);
                    props.setIsUtilitiesShown(false);
                  }}
                >
                  <Zone
                    zone={zone}
                    isSelected={zone.uuid === props.selectedZone.uuid}
                    isSideBarOpen={props.isSideBarOpen}
                    addProject={props.addProject}
                  />
                </li>
              ))}
              {isRequestPending && (
                <li className={styles.item}>
                  <Loader />
                </li>
              )}
            </ul>
            <Flag
              name="zones"
              isDisabled={isRequestPending || !canRetrieveNextZonesIndicators}
              retrieveItems={() =>
                !isRequestPending &&
                retrieveZonesIndicators({
                  filter,
                  index,
                  sort: "ascendingName",
                  size: 10,
                })
              }
            />
            {zones.length === 0 && !isRequestPending && props.isSideBarOpen && (
              <Placeholder />
            )}
          </>
        )}
      </InfiniteScroll>
    </>
  );
}

export { ZonesList };
